import { createSelector } from "reselect"
import { IContract, IContracts } from "./index"

const getContracts = (state: IContracts): IContract[] => state.contracts

export interface SortedContracts {
    sortedContracts: IContract[]
}

export const getSortedContracts = createSelector(
    [getContracts],
    (contracts): IContract[] =>
        contracts.sort((a, b) => a.name.localeCompare(b.name)),
)
